
export const FilesList = [
    {
        desc: "Annie Bassey | 3w",
        title: "Vehicle Flash Charging"
    },
    {
        desc: "Annie Bassey | 3w",
        title: "Vehicle Flash Charging"
    },
    {
        desc: "Annie Bassey | 3w",
        title: "Vehicle Flash Charging"
    },
    {
        desc: "Annie Bassey | 3w",
        title: "Vehicle Flash Charging"
    },    
];